module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<dl class=\'stepped zero\'>\n    <div>\n        <p>\n            <a href=\'' +
((__t = ( sampleUrl )) == null ? '' : __t) +
'\' style=\'font-weight:bold;color:#8bc53f\' target=\'_blank\'>\n                ' +
((__t = ( i18next.t('integrations.import.sample') )) == null ? '' : __t) +
'\n            </a>.\n        </p>\n        <b>' +
((__t = ( i18next.t('organizations.configuration.important_notes') )) == null ? '' : __t) +
'</b>\n        <ul>\n            ';
 notes.forEach(function(note) { ;
__p += '\n                <li>- ' +
__e( note ) +
'</li>\n            ';
 }); ;
__p += '\n        </ul>\n        <br/>\n        <div id=\'errors\' style=\'color: red; max-height: 120px; overflow-y: auto;\'></div>\n    </div>\n    <dt>\n        <label for=\'file\'>' +
((__t = ( i18next.t('common.file').capitalize() )) == null ? '' : __t) +
'</label>\n    </dt>\n    <dd>\n        <input accept=\'.csv\' class=\'text\' id=\'file\' style=\'width: calc(100% - 5px);\' type=\'file\'>\n    </dd>\n</dl>\n';

}
return __p
}